// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".border-line[data-v-f735c0ca]{border-bottom:1px solid #000;border-top:1px solid #000;display:flex;flex-direction:row;height:100%;padding:2rem 0;text-align:left}.partnerlogo[data-v-f735c0ca]{height:5rem!important}.column-between[data-v-f735c0ca]{display:flex;flex-direction:column;height:100%;justify-content:space-between}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
